import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { valetOnSiteSessions } from "./queries";
import { SESSIONS_POLL_INTERVAL_MS } from "../constants";
import { mapSessionToArrival } from "../helpers";
import { splitOnSite, unassignedCount } from "./onSiteTabs";

/*
 * Every car on site, already split into the board's tabs.
 */
export default function useOnSiteSessions(facilityId, now = Date.now()) {
  const { data, loading, error, refetch } = useQuery(valetOnSiteSessions, {
    variables: { facilityId, limit: 1000 },
    skip: !facilityId,
    fetchPolicy: "cache-and-network",
    pollInterval: SESSIONS_POLL_INTERVAL_MS,
  });

  const rawItems = data?.valetSessions?.items;

  const items = useMemo(
    () => (rawItems ?? []).filter(Boolean).map(mapSessionToArrival),
    [rawItems],
  );

  const tabs = useMemo(() => splitOnSite(items, now), [items, now]);

  return {
    items,
    tabs,
    unassigned: useMemo(() => unassignedCount(items), [items]),
    // Keep the board on screen while a poll is in flight.
    loading: loading && !rawItems,
    error,
    refetch,
  };
}
